module.exports = __webpack_public_path__ + "static/media/Dra-Camila-Oraindi.52982781.jpg";